import React from 'react';

import TextArea from '../../common2/TextArea';
import FilesListWithTypes from '../../parcel-finder/claims/common/FilesListWithTypes';
import Uploader from '../../common/Uploader';
import Column from '../../common/layout/Column';
import { useNestedArrayError } from '../../../hooks/useNestedArrayError';

function TakeActionForm(props) {
  const { action, onChange, errors, isSubmitting } = props;

  const filesError = useNestedArrayError('files', errors, action.files);

  return (
    <Column spacing="small">
      <TextArea
        label="Comment"
        name="comment"
        value={action.comment}
        disabled={isSubmitting}
        onChange={onChange}
        placeholder="CLAIM_ACTION_COMMENT_PLACEHOLDER"
      />
      <Uploader
        name="files"
        errorWithTranslation={filesError}
        maxNumberOfFiles={10}
        label="Upload files"
        helpText="CLAIM_ACTION_REQUIRED_FILES_HELPER"
        onChange={onChange}
        files={action.files}
        isDisabled={isSubmitting}
        headers={{ 'X-CLAIM-ID': action.claimId.toString() }}
        filesList={FilesListWithTypes}
      />
    </Column>
  );
}

export default React.memo(TakeActionForm);
